"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _lodash = require("lodash");
var _theme = _interopRequireDefault(require("./styles/theme"));
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
// Define what props.theme will look like

var InputContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-13t1w3p-0"
})(["padding-top:20px;display:flex;min-width:202px;width:auto;position:relative;@media (max-width:370px){grid-template-columns:auto 300px auto;}"]);
var InputStyle = _styledComponents["default"].input.attrs({
  '_lr-hide': function _lrHide(props) {
    return props['_lr-hide'] ? props['_lr-hide'].toString() : 'false';
  }
}).withConfig({
  displayName: "InputStyle",
  componentId: "sc-13t1w3p-1"
})(["grid-area:input;align-self:center;justify-self:center;border:none;border-bottom:1px solid ", ";width:320px;background:transparent;@media (max-width:370px){width:300px;}border-radius:0;cursor:", ";font-family:Raleway,sans-serif;font-weight:500;font-size:16px;letter-spacing:0;text-align:left;padding-bottom:5px;padding-top:", ";color:", ";&:focus{border:none;border-bottom:1px solid ", ";color:", ";outline:none;&::-webkit-input-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&:-moz-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&::-moz-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}&:-ms-input-placeholder{color:transparent;-webkit-transition:color 0.2s ease;transition:color 0.2s ease;}}"], function (props) {
  return props.theme;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.hasFocus ? '10px' : '';
}, function (props) {
  return props.theme;
}, function (props) {
  return (0, _lodash.includes)(props.theme, 'dark') ? _theme["default"].info : _theme["default"].info;
}, function (props) {
  return (0, _lodash.includes)(props.theme, 'dark') ? _theme["default"].info : _theme["default"].info;
});
var Label = _styledComponents["default"].label.withConfig({
  displayName: "Label",
  componentId: "sc-13t1w3p-2"
})(["grid-area:input;position:absolute;font-family:Raleway,sans-serif;font-style:normal;font-weight:normal;line-height:16px;font-size:16px;color:", ";margin-top:", ";text-align:left;cursor:", ";padding-bottom:6px;@media (max-width:370px){width:300px;}transition:0.2s;pointer-events:none;", ";"], function (props) {
  return props.moveLabelUp ? _theme["default"].lightTextDefault : _theme["default"].disabled;
}, function (props) {
  return props.moveLabelUp ? '-20px' : '';
}, function (props) {
  return props.moveLabelUp ? '' : 'pointer';
}, function (props) {
  return !props.moveLabelUp && (0, _styledComponents.css)(["align-self:center;"]);
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-13t1w3p-3"
})(["grid-area:input;cursor:pointer;z-index:2;justify-self:right;align-self:center;width:30px;svg{width:35px;height:35px;}"]);
var Input = /*#__PURE__*/function (_Component) {
  _inherits(Input, _Component);
  var _super = _createSuper(Input);
  function Input(props) {
    var _this;
    _classCallCheck(this, Input);
    _this = _super.call(this, props);
    /**
     * Hook with parent to get value
    */
    _defineProperty(_assertThisInitialized(_this), "update", function (e) {
      // eslint-disable-line
      if ((0, _lodash.isFunction)(_this.props.onChange)) {
        _this.props.onChange(e.currentTarget.value);
      }
      _this.setState({
        value: e.currentTarget.value
      });
    });
    // Label must stay up if we have a value when onBlur
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      // eslint-disable-line
      if (e.currentTarget.value.length < 1) {
        _this.setState({
          moveLabelUp: false
        });
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(e.currentTarget.value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        moveLabelUp: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    });
    _this.state = {
      value: props.value || '',
      moveLabelUp: !(0, _lodash.isEmpty)(props.value),
      type: props.type || ''
    };
    return _this;
  }
  _createClass(Input, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      // Since we store the data locally we
      // want to check if there is a value
      // if so move label up
      if (this.state.value) {
        this.setState({
          moveLabelUp: true
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value,
          moveLabelUp: !(0, _lodash.isEmpty)(nextProps.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var themeDefaultColor = (0, _lodash.includes)(this.props.theme, 'dark') ? _theme["default"].darkTextDefault : _theme["default"].lightTextDefault;
      var iconFillColor = this.props.iconFillColor ? this.props.iconFillColor : themeDefaultColor;
      return /*#__PURE__*/_react["default"].createElement(InputContainer, null, /*#__PURE__*/_react["default"].createElement(InputStyle, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        theme: this.props.theme,
        value: this.state.value,
        onChange: this.update,
        type: this.props.type,
        "_lr-hide": this.props['_lr-hide'],
        moveLabelUp: this.state.moveLabelUp,
        disabled: this.props.disabled
      }), this.props.hasIcon ? /*#__PURE__*/_react["default"].createElement(IconContainer, {
        onClick: this.props.onClickIcon
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: this.props.iconName,
        size: "lg",
        fillColor: iconFillColor
      })) : '', /*#__PURE__*/_react["default"].createElement(Label, {
        moveLabelUp: this.state.moveLabelUp,
        theme: this.props.theme
      }, this.props.label));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Input;
}(_react.Component);
var _default = Input;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(InputContainer, "InputContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
  reactHotLoader.register(InputStyle, "InputStyle", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
  reactHotLoader.register(Label, "Label", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
  reactHotLoader.register(IconContainer, "IconContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
  reactHotLoader.register(Input, "Input", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Input.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();